import { render } from "./testimonials.vue?vue&type=template&id=0804480a"
import script from "./testimonials.vue?vue&type=script&lang=js"
export * from "./testimonials.vue?vue&type=script&lang=js"

import "./testimonials.vue?vue&type=style&index=0&id=0804480a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__